import SEOHead from "@/components/SEOHead";
import { Shield, HardHat, ExternalLink } from "lucide-react";

const CERTIFICATES = [
  {
    icon: Shield,
    title: "Public & Products Liability",
    subtitle: "Underwritten by Hiscox Insurance Company Limited",
    href: "/docs/pl-certificate.pdf",
    fields: [
      ["Insured", "Can Do Payments Limited"],
      ["Policy Number", "PL-PSC10003297244/04"],
      ["Cover Type", "Public & Products Liability"],
      ["Indemnity Limit", "£2,000,000"],
      ["Period From", "06 July 2026"],
      ["Period To", "05 July 2027"],
    ],
    footnote:
      "Indemnity limit of £2,000,000 each and every claim or loss, excluding defence costs and representation costs. Underwritten by Hiscox Insurance Company Limited.",
  },
  {
    icon: HardHat,
    title: "Employers' Liability",
    subtitle: "Underwritten by Hiscox Insurance Company Limited",
    href: "/docs/el-certificate.pdf",
    fields: [
      ["Policyholder", "Can Do Payments Limited"],
      ["Policy Number", "PL-PSC10003297244/04"],
      ["Cover Type", "Employers' Liability"],
      ["Minimum Cover", "£5,000,000"],
      ["Period From", "06 July 2026"],
      ["Period To", "05 July 2027"],
    ],
    footnote:
      "This policy satisfies the requirements of the relevant law applicable in Great Britain, Northern Ireland, the Isle of Man, and the Islands of Jersey, Guernsey and Alderney, as required by the Employers' Liability (Compulsory Insurance) Regulations 1998.",
  },
];

export default function BusinessInsurancePage() {
  return (
    <div>
      <SEOHead title="Business Insurance" description="Can Do Payments Ltd holds public and products liability and employers' liability insurance underwritten by Hiscox Insurance Company Limited." path="/business-insurance" />
      <section className="hero-gradient py-12 md:py-16">
        <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8">
          <h1 className="font-heading text-3xl sm:text-4xl font-bold text-brand-black tracking-tight">Business Insurance</h1>
          <p className="text-sm text-brand-grey mt-2">Public &amp; Products Liability and Employers&rsquo; Liability Insurance</p>
        </div>
      </section>
      <section className="py-16 bg-white">
        <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 space-y-8">
          {CERTIFICATES.map(({ icon: Icon, title, subtitle, href, fields, footnote }) => (
            <div key={title} className="bg-gray-50 border border-brand-light-grey rounded-2xl p-8 sm:p-10 space-y-6">
              <div className="flex items-center gap-3 mb-4">
                <Icon size={28} className="text-brand-aqua" />
                <div>
                  <h2 className="font-heading text-xl font-bold text-brand-black">{title}</h2>
                  <p className="text-sm text-brand-grey">{subtitle}</p>
                </div>
              </div>
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                {fields.map(([label, value]) => (
                  <div key={label} className="bg-white border border-brand-light-grey rounded-xl p-4">
                    <p className="text-xs text-brand-grey uppercase tracking-wider mb-1">{label}</p>
                    <p className="text-sm font-bold text-brand-black">{value}</p>
                  </div>
                ))}
              </div>
              <p className="text-xs text-brand-grey leading-relaxed">{footnote}</p>
              <a href={href} target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-2 text-sm font-semibold text-brand-aqua hover:text-brand-aqua-dark transition-colors">
                Download certificate (PDF) <ExternalLink size={14} />
              </a>
            </div>
          ))}
        </div>
      </section>
    </div>
  );
}
